var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseSmall1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "close_small"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6035_26144",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6035_26144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_small_2",
    d: "M10 11.5027L6.8306 14.6721C6.63024 14.8725 6.37523 14.9727 6.06557 14.9727C5.75592 14.9727 5.50091 14.8725 5.30055 14.6721C5.10018 14.4718 5 14.2168 5 13.9071C5 13.5975 5.10018 13.3424 5.30055 13.1421L8.46995 9.97268L5.30055 6.8306C5.10018 6.63024 5 6.37523 5 6.06557C5 5.75592 5.10018 5.50091 5.30055 5.30055C5.50091 5.10018 5.75592 5 6.06557 5C6.37523 5 6.63024 5.10018 6.8306 5.30055L10 8.46995L13.1421 5.30055C13.3424 5.10018 13.5975 5 13.9071 5C14.2168 5 14.4718 5.10018 14.6721 5.30055C14.8907 5.51913 15 5.77869 15 6.07923C15 6.37978 14.8907 6.63024 14.6721 6.8306L11.5027 9.97268L14.6721 13.1421C14.8725 13.3424 14.9727 13.5975 14.9727 13.9071C14.9727 14.2168 14.8725 14.4718 14.6721 14.6721C14.4536 14.8907 14.194 15 13.8934 15C13.5929 15 13.3424 14.8907 13.1421 14.6721L10 11.5027Z",
    fill: "#357EFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall1);
export default __webpack_public_path__ + "static/media/close_small (1).ec40c7331289c2a75bb885ffa04a6beb.svg";
export { ForwardRef as ReactComponent };